module.exports = __webpack_public_path__ + "static/media/certificate_for_the_use_of_green_mark_16124_pdf.1b638879.pdf";